export const ProformaSeinpro = {
  RUC: '0993379644001',
  location: 'San Martín Y Manuel Villavicencio',
  telfs: '0992873776',
  email: 'info@seinproec.com',
  sequential: '000000',
}

export const PaymentTypes = {
  anticipo: {
    label: 'Anticipo',
    value: 'anticipo',
  },
  avance: {
    label: 'Avance de obra',
    value: 'avance',
  },
  contraentrega: {
    label: 'Contraentrega',
    value: 'contraentrega',
  },
}

export const PaymentValues = [50, 30, 20]

export const StatusProforma = {
  draft: {
    label: 'Borrador',
    value: 'draft',
    color: 'gray',
    roles: ['admin', 'user'],
  },
  inReview: {
    label: 'En revisión',
    value: 'inReview',
    color: 'orange',
    roles: ['admin'],
  },
  sent: {
    label: 'Enviada',
    value: 'sent',
    color: 'blue',
    roles: ['admin'],
  },
  approved: {
    label: 'Aprobada',
    value: 'approved',
    color: 'green',
    roles: ['admin'],
  },
  rejected: {
    label: 'Rechazada',
    value: 'rejected',
    color: 'red',
    roles: ['admin'],
  },
  canceled: {
    label: 'Cancelada',
    value: 'canceled',
    color: 'gray',
    roles: ['admin'],
  },
}

export const Entities = {
  'raw-material': {
    label: 'Materia prima',
    value: 'raw-material',
  },
  block: {
    label: 'Bloque',
    value: 'block',
  },
  receipt: {
    label: 'Receta',
    value: 'receipt',
  },
  accessory: {
    label: 'Accesorio',
    value: 'accessory',
  },
}

export const DueDateOptions = {
  days: {
    label: 'Días',
    value: 'days',
  },
  weeks: {
    label: 'Semanas',
    value: 'weeks',
  },
  months: {
    label: 'Meses',
    value: 'months',
  },
  years: {
    label: 'Años',
    value: 'years',
  },
}

export const ProformaDescription =
  '<p><strong>Nota:</strong> <em><u>El precio no incluye iva.</u></em></p><p><strong>Nota:</strong> la presente oferta no incluye, resanes, acometidas o instalaciones no descritas en la presente cotización, no se realizan devoluciones por tema de material sobrante o de medidas inferiores a las descrita.</p><p><strong>Tiempo de entrega:</strong> Se excluyendo tiempos de importación de equipos que no se encuentren en stock al momento de efectuarse el trabajo. Se inicará el trabajo de 2 a 3 dias luego de efectuarse la entrega del anticipo debudo a que es el tiempo que se demora en la compra del material inicial.</p><p><strong>Documentos entregables:</strong> Ficha tecnica de equipos instalados, planos hidraulicos y electricos, informe final de ingenieria para entrega a bomberos.</p>'

export const SeinproSVG =
  'data:image/svg+xml;base64,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'
